// @ts-nocheck
import { mapState } from "./state";
import { focusOnTomb } from "./camera";
import { ensureHeadstoneInDOM } from "./holes";
import { fetchViewportIfNeeded } from "./data-sync";
import { openViewModal, restoreGrave } from "./grave-render";
import { coordsFromHoleId } from "../utils/hole-id";
import type { LegacyHeadstone } from "../utils/dto";

export type NavigateToHeadstoneOptions = {
  openModal?: boolean;
};

/** Center map on a headstone, restore DOM, optional view modal. */
export function navigateToHeadstone(
  legacy: LegacyHeadstone,
  options: NavigateToHeadstoneOptions = {},
): boolean {
  const { openModal = true } = options;
  const [bx, by] = coordsFromHoleId(legacy.holeId);
  const { hole, holeId, x, y } = ensureHeadstoneInDOM(bx, by);

  focusOnTomb(x, y);

  fetchViewportIfNeeded().catch(() => null);

  if (!hole) return false;

  mapState.gravesData[holeId] = legacy;
  if (legacy.id) mapState.graveIdToHole.set(legacy.id, holeId);
  restoreGrave(hole, legacy);
  hole.classList.add("pulse");
  setTimeout(() => hole.classList.remove("pulse"), 900);

  if (openModal) openViewModal(hole);
  return true;
}
